export const FETCH_INVOICEDETAILS_REQUEST = "FETCH_INVOICEDETAILS_REQUEST";
export const FETCH_INVOICEDETAILS_SUCCESS = "FETCH_INVOICEDETAILS_SUCCESS";
export const FETCH_INVOICEDETAILS_FAILURE = "FETCH_INVOICEDETAILS_FAILURE";
